import api from "../redux/apis/api";

function triggerBrowserDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadEntityTemplate(entity) {
  const clean = String(entity || "").trim().toLowerCase();
  const response = await api.get(`/import-export/${clean}/template`, {
    responseType: "blob",
  });
  triggerBrowserDownload(response.data, `${clean}_template.xlsx`);
}

export async function uploadEntityFile(entity, file, options = {}) {
  const clean = String(entity || "").trim().toLowerCase();
  const form = new FormData();
  form.append("file", file);
  const validateOnly = options?.validateOnly ? "true" : "false";
  const { data } = await api.post(`/import-export/${clean}/upload?validateOnly=${validateOnly}`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
